import cls from "classnames";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import ErrorIcon from "images/errorIcon.svg?react";
import Button from "components/ui/Button";

import styles from "./index.module.scss";

type Props = {
  children: ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
};

/**
 * A failure that belongs to a form, a panel or a page, with an optional action to
 * try whatever failed again. Announces itself, so it is heard when it appears.
 *
 * For an error that belongs to one form control, reach for `FieldError` instead.
 */
export default function ErrorBanner(props: Props) {
  const { t } = useTranslation();

  return (
    <div role="alert" className={cls(styles.banner, props.className)}>
      <ErrorIcon className={styles.icon} />
      <div className={styles.content}>
        <div className={styles.message}>{props.children}</div>
        {props.onRetry && (
          <Button variant="secondary" size="extra-small" onClick={props.onRetry}>
            {props.retryLabel ?? t("Common.actions.tryAgain")}
          </Button>
        )}
      </div>
    </div>
  );
}
